/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1NotificationMobileAppSharedSelectionSummaryQueryResponse,
  GetApiV1NotificationMobileAppSharedSelectionSummaryQueryParams,
  GetApiV1NotificationMobileAppSharedSelectionSummary401,
  GetApiV1NotificationMobileAppSharedSelectionSummary500,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppSharedSelectionSummary.ts";

function getGetApiV1NotificationMobileAppSharedSelectionSummaryUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/notification/mobile-app/shared/selection-summary` as const,
  };
  return res;
}

/**
 * @description Retorna a quantidade de alunos impactados pelo filtro, a quantidade de turmas selecionadas e a quantidade de status de matrícula informados. Quando `isAllClassStudents=true`, ignora `classStudentIds` e considera todas as turmas ativas. **(Requer Authorization para autenticação)**
 * @summary Resumo da seleção de notificação (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app/shared/selection-summary}
 */
export async function getApiV1NotificationMobileAppSharedSelectionSummary(
  params?: GetApiV1NotificationMobileAppSharedSelectionSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1NotificationMobileAppSharedSelectionSummaryQueryResponse,
    ResponseErrorConfig<
      | GetApiV1NotificationMobileAppSharedSelectionSummary401
      | GetApiV1NotificationMobileAppSharedSelectionSummary500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1NotificationMobileAppSharedSelectionSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
